// extracted by mini-css-extract-plugin
export default {"teamSingle":"MultipleSlide_teamSingle__bQZAG"};